import React from "react";
import Layout from "../../layout/Layout";

const ApprovalList = ({ bpName }) => {
  return (
    <Layout>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {Array.from({ length: 100 }).map((_, i) => {
          return (
            <div key={i}>
              {i} {bpName}
            </div>
          );
        })}
      </div>
    </Layout>
  );
};

export default ApprovalList;
